(function($) {
  'use strict';
  Drupal.behaviors.headerSearchToggle = {
    attach: function(context) {
      const $searchToggle = $('.search__toggle', context);
      const $searchInput = $('.search__container', context);
      const $headerSearch = $('.header__search', context);

      $searchToggle.unbind().on('click', function() {
        // Add class to input container when toggle is clicked.
        $searchInput.toggleClass('is-open');
        $headerSearch.toggleClass('is-open');
        $searchInput.find('input.form-text').focus();
      });

      // Listen for click events in the header that aren't within the search
      // container, and collapse it if that's the case.
      $(document, context).on('mousedown', 'header', function(event) {
        let $target = $(event.target);
        if ($target.parents('.header__search').length < 1) {
          $searchInput.removeClass('is-open');
          $headerSearch.removeClass('is-open');
        }
      });
    }
  };
})(jQuery);
